"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NATIVE_DENOMINATION = void 0;
/**
 * Denomination in native token.
 */
exports.NATIVE_DENOMINATION = new Uint8Array();
